





















import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'
import KintaiAction from '@/components/kintai/molecules/KintaiAction.vue'
import ShouninStatus from '@/components/kintai/molecules/ShouninStatus.vue'
import { KintaiActionMenu } from '@/components/kintai/types'
import { TcwFormDate } from '@/tcw/domain/types'

@Component({
  components: { TcwGetsudoPicker, KintaiAction, ShouninStatus }
})
export default class ShouninKintaiLocalHeader extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected teishutsu!: ApiGeneralSinglePayload
  @Prop({ default: () => [] })
  private actions!: KintaiActionMenu[]
  @Prop({ type: Boolean, default: () => false })
  private processingAction!: boolean

  get teishutsuGetsudoDate(): TcwFormDate {
    if (typeof this.teishutsu?.teishutsuGetsudo === 'string') {
      return this.tcw.dateOf(this.teishutsu.teishutsuGetsudo)
    } else {
      return this.du.now()
    }
  }
  get getsudoStr(): string {
    return this.du.convertDateToStr(this.teishutsuGetsudoDate, 'YYYY年MM月度')
  }
  get shouninUserList(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.teishutsu?.shouninUserList)
      ? (this.teishutsu.shouninUserList as ApiGeneralObjectArrayPayload)
      : []
  }
  get hasBall(): boolean {
    return this.shouninUserList.some(user => user.id === this.loginUserId)
  }

  @Emit()
  private selectAction(command: string) {
    console.log(command)
  }
}
